import { useState, useCallback } from 'react'

const STORAGE_KEY = 'modern-high-contrast'

function getInitial(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored !== null) return stored === 'true'
  return window.matchMedia('(prefers-contrast: more)').matches
}

export function useHighContrast() {
  const [highContrast, setHighContrast] = useState(getInitial)

  const toggle = useCallback(() => {
    setHighContrast((prev) => {
      const next = !prev
      localStorage.setItem(STORAGE_KEY, String(next))
      return next
    })
  }, [])

  return { highContrast, toggle } as const
}
